import { Injectable} from '@angular/core';
import { Headers } from '@angular/http';

@Injectable()
export class HeaderService {
    private headers: Headers;
    private apiRoute = "/api/v0.1";
    private callbackPort = '0626';
    
    constructor() {
        this.headers = new Headers();
    }
    
    getApi(): string {
        return this.apiRoute;
    }
    
    setHeader(header: {nombre: string, valor: string}) {
        if (!!this.headers.get(header.nombre))
            this.headers.delete(header.nombre)
        this.headers.append(header.nombre, header.valor);        
    }
    
    getHeader(nombre: string): string {
        return this.headers.get(nombre);
    }
    
    getHeaders() {
        return this.headers;
    }

    getCallbackPort(): string {
        return this.callbackPort;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_services/header.service.ts